import { useState, useEffect } from 'react';
import SearchIcon from '@assets/images/mobile_searchIcon.png';
import styles from './index.module.scss';
import cs from 'classnames';
import {
  Col,
  EmptyStory,
  Flex,
  InputCore,
  Loading,
  Row,
  Tag,
  ToggleStory,
} from '@components';
import { BiSearchAlt } from 'react-icons/bi';
import MobileStoryCard from './StoryCard';
import { useGetHashtagList, useGetStories } from '@coreStory/useCase';
import { IStoryList } from '@coreStory/type';
import { useStore } from '@store';

type Stories = 'userStories' | 'nightWhisper' | 'newStories' | 'publicStories';
const MobileLibrary = () => {
  const { theme } = useStore();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchMode, setSearchMode] = useState<boolean>(false);
  const [storyType, setStoryType] = useState<Stories>();
  const [storyHashtagAvtice, setStoryHashtagAvtice] = useState<any>();
  const [storiesData, setStoriesData] = useState<IStoryList[]>();
  const [filteredStories, setFilteredStories] = useState<IStoryList[]>([]);

  const getNewHomeStory = useGetStories();
  const getDailyNightStory = useGetStories();
  const getPublicHashtag = useGetHashtagList();
  const getPublicStory = useGetStories();

  useEffect(() => {
    getPublicHashtag.mutate({ public: true });
  }, []);

  useEffect(() => {
    getDailyNightStory.mutate({
      hashtagid: theme === 'night' ? 2 : 1,
      public: true,
    });
  }, [theme]);

  const handleGetPublicStory = () => {
    getPublicStory.mutate({ public: true, hashtagid: 0 });
  };

  const handleGetNewStory = () => {
    getNewHomeStory.mutate({ hashtagid: 3, public: true });
  };

  const handleGetDayNightStory = () => {
    getDailyNightStory.mutate({
      hashtagid: theme === 'night' ? 2 : 1,
      public: true,
    });
  };

  useEffect(() => {
    setStoryHashtagAvtice(0);
  }, [storyType]);

  useEffect(() => {
    if (getDailyNightStory.data) {
      setStoriesData(getDailyNightStory?.data);
      setStoryType('nightWhisper');
    }
  }, [getDailyNightStory.data]);

  useEffect(() => {
    if (getNewHomeStory.data) {
      setStoriesData(getNewHomeStory?.data);
      setStoryType('newStories');
    }
  }, [getNewHomeStory.data]);

  useEffect(() => {
    if (getPublicStory.data) {
      setStoriesData(getPublicStory?.data);
      setStoryType('publicStories');
    }
  }, [getPublicStory.data]);

  useEffect(() => {
    if (
      getPublicStory.isLoading ||
      getDailyNightStory.isLoading ||
      getNewHomeStory.isLoading
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [
    getPublicStory.isLoading,
    getNewHomeStory.isLoading,
    getDailyNightStory.isLoading,
  ]);

  const filterData = (data: IStoryList[], filterValue = ''): IStoryList[] => {
    return data.filter(
      (story) =>
        story?.StoryText?.toLowerCase().trim().includes(filterValue) ||
        story?.StoryName?.toLowerCase().trim().includes(filterValue),
    );
  };

  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    const text = event.currentTarget.value.toLowerCase().trim();
    if (text.length >= 3) {
      setSearchMode(true);
      storiesData && setFilteredStories(filterData(storiesData, text));
    } else if (!text) {
      setSearchMode(false);
      storiesData && setFilteredStories(storiesData);
    }
  };
  const handleStoryHashtag = (id: any, type: Stories) => {
    setStoryHashtagAvtice(id);
    if (type === 'publicStories') {
      getPublicStory.mutate({ public: true, hashtagid: id });
    }
  };
  return (
    <div>
      <div className={styles['top_box']}>
        <div className={styles['title_box']}>
          <img src={SearchIcon} alt="search" />
          <h2>Tadatoon Library</h2>
        </div>
        {/* <div className={styles['toggle']}>
          <ToggleStory />
        </div> */}
      </div>
      <div className={cs([styles['stories_filters'], 'mobile_story_filters'])}>
        <div
          onClick={handleGetPublicStory}
          className={cs([
            styles['filter_btn'],
            storyType === 'publicStories' ? styles['active'] : '',
          ])}>
          <span>
            {' '}
            <span>Public Stories</span>
          </span>
        </div>
        <div
          onClick={handleGetDayNightStory}
          className={cs([
            styles['filter_btn'],
            storyType === 'nightWhisper' ? styles['active'] : '',
          ])}>
          <span>
            {' '}
            {theme === 'night' ? 'Night’s Whisper' : 'Daily Adventures'}
          </span>
        </div>
        <div
          onClick={handleGetNewStory}
          className={cs([
            styles['filter_btn'],
            storyType === 'newStories' ? styles['active'] : '',
          ])}>
          <span>
            {' '}
            <span>New Home New Story</span>
          </span>
        </div>
      </div>
      <div className={styles['stories_container']}>
        <div className={styles['search_box']}>
          <InputCore
            placeholder="search"
            suffix={<BiSearchAlt />}
            className={styles['input']}
            onInput={(e) => handleInput(e)}
          />
        </div>
        {storyType === 'publicStories' && getPublicHashtag.data && (
          <Flex
            style={{
              maxWidth: '100%',
              overflowX: 'auto',
              paddingBottom: 5,
              marginBottom: 20,
            }}>
            <Tag
              style={{
                borderColor: '#8A8181',
                cursor: 'pointer',
                color: storyHashtagAvtice === 0 ? '#fff' : '#8A8181',
                borderRadius: 50,
                background:
                  storyHashtagAvtice === 0 ? '#8A8181' : 'transparent',
              }}
              onClick={() => handleStoryHashtag(0, storyType)}>
              #All
            </Tag>
            {getPublicHashtag.data.map((item) => (
              <Tag
                key={item.HashtagID}
                style={{
                  borderColor: '#8A8181',
                  cursor: 'pointer',
                  color:
                    storyHashtagAvtice === item.HashtagID ? '#fff' : '#8A8181',
                  borderRadius: 50,
                  background:
                    storyHashtagAvtice === item.HashtagID
                      ? '#8A8181'
                      : 'transparent',
                }}
                onClick={() => handleStoryHashtag(item.HashtagID, storyType)}>
                #{item.Hashtag}
              </Tag>
            ))}
          </Flex>
        )}

        <Row gutter={[0, 20]}>
          {isLoading ? (
            <Loading />
          ) : searchMode ? (
            filteredStories.length ? (
              filteredStories?.map((item, index) => {
                return (
                  <Col key={index} xs={24}>
                    <MobileStoryCard {...item} />
                  </Col>
                );
              })
            ) : (
              <EmptyStory />
            )
          ) : storiesData?.length ? (
            storiesData?.map((item, index) => {
              return (
                <Col key={index} xs={24}>
                  <MobileStoryCard {...item} />
                </Col>
              );
            })
          ) : (
            <EmptyStory />
          )}
        </Row>
      </div>
    </div>
  );
};

export default MobileLibrary;
